import { render } from "./MapExample.vue?vue&type=template&id=1580bbe1"
import script from "./MapExample.vue?vue&type=script&lang=js"
export * from "./MapExample.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__